import React, { useContext } from 'react';
import { StateContext } from '../state/StateProvider';

export default () => {
	const {
		state: { theme },
	} = useContext(StateContext);
	return <img height="40" src={`./${theme === 'dark' ? 'logo' : 'logo_light'}.svg`} alt="logo" />;
};
